import { SET_PAGE } from '../constants/actionTypes';

export const setCurrentPage = page => ({
    type: SET_PAGE,
    page: page
});




// WEBPACK FOOTER //
// ./src/actions/nav.js